// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","flag":"navItemProfile-module_flag_P4s","flagProfile":"navItemProfile-module_flagProfile_aWP"};